import { useState } from "react";
import { Link } from "react-router-dom";
import ContactFormModal from "@/components/ContactFormModal";

export default function Footer() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-white/10 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-brand text-3xl text-white mb-4">FIND YOUR BREAKTHROUGH</h3>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-md">
              From forty years of chaos to clarity. Chris Merlo's story of addiction, redemption,
              and the protocol that changed everything.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] font-bold mb-4">Quick Links</h4>
            <div className="space-y-3">
              <Link to="/" className="block text-zinc-400 text-sm hover:text-white transition-colors" data-testid="footer-home">Home</Link>
              <Link to="/clarity-protocol" className="block text-zinc-400 text-sm hover:text-white transition-colors" data-testid="footer-protocol">The Clarity Protocol</Link>
              <a href="/#science" className="block text-zinc-400 text-sm hover:text-white transition-colors">The Science</a>
              <Link to="/media-kit" className="block text-zinc-400 text-sm hover:text-white transition-colors">Media Kit</Link>
              <Link to="/book-club-kit" className="block text-zinc-400 text-sm hover:text-white transition-colors">Book Club Kit</Link>
              <a href="#pricing" className="block text-zinc-400 text-sm hover:text-white transition-colors">Pre-Order</a>
              <a href="#merch" className="block text-zinc-400 text-sm hover:text-white transition-colors">Merchandise</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] font-bold mb-4">Connect</h4>
            <div className="space-y-3">
              <a href="#speaking" className="block text-zinc-400 text-sm hover:text-white transition-colors">Book Chris to Speak</a>
              <button
                onClick={() => setContactOpen(true)}
                className="block text-zinc-400 text-sm hover:text-white transition-colors text-left"
                data-testid="footer-contact"
              >
                Get In Touch
              </button>
            </div>
          </div>
        </div>

        <div className="gold-line mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-xs">
            &copy; {new Date().getFullYear()} Chris Merlo / FYB Life. All rights reserved.
          </p>
          <p className="text-zinc-600 text-xs">
            The Forty Year Bender &mdash; Launching June 4, 2026
          </p>
        </div>
      </div>

      <ContactFormModal open={contactOpen} onClose={() => setContactOpen(false)} />
    </footer>
  );
}
